import type { ReactNode } from 'react'
import { SemRede } from '../dados/api.js'
import type { AcaoAdmin, AcaoAuditoria, PerfilNome } from '../dados/api.js'

/// Peças compartilhadas pelas telas de administração.

export const rotuloPerfil: Record<PerfilNome, string> = {
  SUPERADMIN: 'Administrador supremo',
  ADMIN: 'Administrador',
  GERENTE_CONTRATO: 'Gerente de contrato',
  ENGENHEIRO_SEGURANCA: 'Engenheiro de segurança',
  TECNICO_SEGURANCA: 'Técnico de segurança',
  ENCARREGADO: 'Encarregado',
  COLABORADOR: 'Colaborador',
  RESPONSAVEL_NC: 'Responsável por NC',
}

export const rotuloAcao: Record<AcaoAuditoria, string> = {
  CRIACAO: 'Criou',
  EDICAO: 'Alterou',
  EXCLUSAO: 'Excluiu',
  MUDANCA_STATUS: 'Mudou o status',
  REVISAO_CRITICIDADE: 'Revisou a criticidade',
}

export const corAcao: Record<AcaoAuditoria, string> = {
  CRIACAO: 'bg-leve/10 text-leve',
  EDICAO: 'bg-marinho-50 text-marinho',
  EXCLUSAO: 'bg-alta/10 text-alta',
  MUDANCA_STATUS: 'bg-moderada/10 text-moderada',
  REVISAO_CRITICIDADE: 'bg-limao/20 text-marinho-900',
}

export function PainelAdmin({
  titulo,
  subtitulo,
  children,
}: {
  titulo: string
  subtitulo: string
  children: ReactNode
}) {
  return (
    <section>
      <div className="mb-4">
        <h2 className="text-lg font-bold text-slate-900">{titulo}</h2>
        <p className="text-sm text-slate-600">{subtitulo}</p>
      </div>
      {children}
    </section>
  )
}

/// As telas de administração leem o banco direto; offline elas não têm o que
/// mostrar. A mensagem diz isso em vez de fingir que a lista está vazia.
export function SemRedeAqui({ erro }: { erro: unknown }) {
  const semRede = erro instanceof SemRede
  return (
    <div className="cartao p-6 text-center">
      <p className="font-semibold text-slate-700">
        {semRede ? 'Sem conexão com o servidor' : 'Não foi possível carregar'}
      </p>
      <p className="mt-1 text-sm text-slate-500">
        {semRede
          ? 'Esta tela consulta o banco em tempo real e não funciona offline, ao contrário das inspeções.'
          : ((erro as Error)?.message ?? 'Erro desconhecido.')}
      </p>
    </div>
  )
}

/// Data por extenso quando é antiga, relativa quando é recente — que é como se
/// lê uma trilha de auditoria: "há 5 min" diz mais do que o horário exato.
export function QuandoFoi({ iso }: { iso: string }) {
  const data = new Date(iso)
  const minutos = Math.floor((Date.now() - data.getTime()) / 60000)
  const texto =
    minutos < 1
      ? 'agora'
      : minutos < 60
        ? `há ${minutos} min`
        : minutos < 60 * 24
          ? `há ${Math.floor(minutos / 60)} h`
          : minutos < 60 * 24 * 7
            ? `há ${Math.floor(minutos / 1440)} d`
            : data.toLocaleDateString('pt-BR')
  return (
    <time dateTime={iso} title={data.toLocaleString('pt-BR')}>
      {texto}
    </time>
  )
}

export const rotuloAcaoAdmin: Record<AcaoAdmin, string> = {
  PERFIL_CONCEDIDO: 'Concedeu perfil',
  PERFIL_REMOVIDO: 'Retirou perfil',
  ACESSO_CONCEDIDO: 'Liberou acesso',
  ACESSO_REVOGADO: 'Tirou o acesso',
  USUARIO_DESATIVADO: 'Desativou',
  USUARIO_REATIVADO: 'Reativou',
  USUARIO_EXCLUIDO: 'Excluiu',
  USUARIO_CRIADO: 'Cadastrou',
  OBRAS_ALTERADAS: 'Alterou obras',
  SINCRONIZACAO_RM: 'Sincronizou com o RM',
  CONFIGURACAO_ALTERADA: 'Mudou configuração',
  VOLTOU_A_SEGUIR_RM: 'Voltou a seguir o RM',
  CHECKLIST_CRIADO: 'Criou checklist',
  CHECKLIST_ALTERADO: 'Alterou checklist',
  CHECKLIST_DESATIVADO: 'Desativou checklist',
  CHECKLIST_REATIVADO: 'Reativou checklist',
}

export const corAcaoAdmin: Record<AcaoAdmin, string> = {
  PERFIL_CONCEDIDO: 'bg-limao/20 text-marinho-900',
  PERFIL_REMOVIDO: 'bg-moderada/10 text-moderada',
  ACESSO_CONCEDIDO: 'bg-leve/10 text-leve',
  ACESSO_REVOGADO: 'bg-moderada/10 text-moderada',
  USUARIO_DESATIVADO: 'bg-moderada/10 text-moderada',
  USUARIO_REATIVADO: 'bg-leve/10 text-leve',
  USUARIO_EXCLUIDO: 'bg-alta/10 text-alta',
  USUARIO_CRIADO: 'bg-leve/10 text-leve',
  OBRAS_ALTERADAS: 'bg-marinho-50 text-marinho',
  SINCRONIZACAO_RM: 'bg-limao/20 text-marinho-900',
  CONFIGURACAO_ALTERADA: 'bg-moderada/10 text-moderada',
  VOLTOU_A_SEGUIR_RM: 'bg-marinho-50 text-marinho',
  CHECKLIST_CRIADO: 'bg-leve/10 text-leve',
  CHECKLIST_ALTERADO: 'bg-marinho-50 text-marinho',
  CHECKLIST_DESATIVADO: 'bg-moderada/10 text-moderada',
  CHECKLIST_REATIVADO: 'bg-leve/10 text-leve',
}
